export default "__VITE_ASSET__l44KaSXo__"